import { useBetterStackStatusPageQuery } from '~/hooks/tanstack-query/betterstack/useBetterStackStatusQuery'

import { IncidentBanner } from './IncidentBanner'
import { MaintenanceBanner } from './MaintenanceBanner/MaintenanceBanner'

export const BetterStackBanner = () => {
    const { data } = useBetterStackStatusPageQuery()

    if (!data) return null

    const { incident, maintenance } = data

    return (
        <div className="flex flex-col gap-[1px]" data-test="betterstack-banner-loaded">
            {incident && <IncidentBanner {...incident} />}
            {maintenance && <MaintenanceBanner {...maintenance} />}
        </div>
    )
}
